import { render } from "./SpinnerBlock.vue?vue&type=template&id=3352f8fd&scoped=true"
const script = {}

import "./SpinnerBlock.vue?vue&type=style&index=0&id=3352f8fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3352f8fd"]])

export default __exports__